import React, { useContext } from "react";
import cx from 'classnames';
import styles from './index.module.scss';
import { pagePathUrl } from '@/constants/url';
import { StoreContext, namespace } from '@/context';
import { decodeSubjectText } from '@/utils/html';

export interface ListContentData {
  tid?: number;
  title: string;
  num?: number | React.ReactNode,
  slot?: string | React.ReactNode;
}

interface ListCardProps<T> {
  id?: string;
  width? :number;
  defaultStyle?: boolean;
  data: (T & ListContentData)[];
  title: string | React.ReactNode;
  /* 埋点position字段 */
  position: string;
}

// 社区热点/社区公告列表卡片组件
function ListCard<T>({ title, width, data = [], defaultStyle = true, id = '', position }: ListCardProps<T>) {
  const { state } = useContext(StoreContext);
  const { track, TRACK_EVENTS } = state[namespace.app].sensors || {};
  const { pcActiveChannelName } = state[namespace.home];

  const handleTrackCb = (title: string, tid: number) => {
    track?.(TRACK_EVENTS?.[namespace.home].threadEntryClick.name, {
      list_name: pcActiveChannelName,
      thread_name: title,
      thread_tid: tid,
      position,
    }, namespace.home);
  }

  const renderNo = (item: ListContentData, index: number) => {
    if (item.num) {
      return item.num;
    }
    return index + 1;
  }
  return (
    <div id={id} className={styles.listCardContainer} style={{width: width || '100%'}}>
      <div className={styles.title}>{title}</div>
      <ul className={styles.listContent}>
        {
          data.map((item, index) => (
            <li
              key={`${item.tid ?? 'no-tid'}-${item.title}-${index}`}
              className={styles.listItem}
              onClick={() => {
                if (item.tid) {
                  handleTrackCb(item.title, item.tid);
                  window.open(`${pagePathUrl.detail}?tid=${item.tid}`);
                }
              }}
            >
              <div className={styles.link}>
                <div className={cx(styles.num, !defaultStyle ? styles.normalNum : '')}>{renderNo(item, index)}</div>
                <div className={styles.text}>{decodeSubjectText(item.title)}</div>
              </div>
              {item.slot && <div className={styles.slot}>{item.slot}</div>}
            </li>
          ))
        }
      </ul>
    </div>
  )
}

export default ListCard;

